import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NextComponentService } from '../../../../../lib/services/next-component.service';
import { IComponentDetails } from '../../../../../../src/lib/interfaces/component-details.interface';
import { ComponentName } from '../../../../../lib/enum/component-name.enum';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { StepComponent } from '../stepcomponent.class';
import { ResidenceInfoComponent } from '../residence-info/residence-info.component';
import { IConfig, IDescriptionValuePair } from '../../../../interfaces/config.interface';
import { CreditAppService } from '../../../../services/credit-app.service';
import { StepType } from '../../../../enum/step-type.enum';
import { CustomValidator } from '../../../../utils/customValidatorDOB';
import { PreviousComponentService } from '../../../../services/previous-component.service';
import { getLookupMappings, validateAllFormFields, isIEorEdge, getBackButton } from '../../../../../lib/utils/utils.functions';
import { CreditApplicationConfig, LookupMappingInformation, PreQualLeadInfo } from '../../../../../lib/interfaces/credit-application-config.interface';
import { PersonalInformation2, SecurityInformation } from '../../../../interfaces/credit-application.interface';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { NextCTAClick, FormStarted, ServerError } from '../../../../../lib/actions/analytics.action';
import { take } from 'rxjs/operators';
import { IAnalyticsErrorResponse } from '../../../../../lib/interfaces/analytics.interface';
import { UDOConstant, ErrorType } from '../../../../../lib/enum/analytics.enum';
import { NotificationsService } from '../../../../services/notifications.service';
import { NotificationType, INotification } from '../../../../interfaces/notification.interface';
import { StateService } from '../../../../services/state.service';
import { IValidateLeadRequest } from '../../../../../lib/interfaces/lead-validation.interface';
import { FormInfoService } from 'projects/dt-an-prequalification-lib/src/lib/services/form-info.service';


export { Actions } from '../../../../actions/analytics.action';

@Component({
  selector: 'dt-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss'],
  standalone: false
})
export class PersonalInfoComponent implements OnInit {
  type: StepType = StepType.Buyer;
  personalInfoForm: UntypedFormGroup;
  dobMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  SCData: any;
  phonePattern = '^[(]{1}[0-9]{3}[)]{1}[ ]{1}[0-9]{3}[-]{1}[0-9]{4}$';
  datePattern = '^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{4}$';
  ssnPattern = '^[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{4}$';
  ssnPattern1 = '^[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{4}$';
  ssnPattern2 = '^[0-9]{9}$';
  namePattern = '^(?!\\s*$)[A-Za-z\\s\-\'\`\’\‘]*$';
  MIPattern = '^[A-Za-z]*$';
  emailPattern = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$';
  ssnflag = false;
  IE = false;
  creditAppConfigData: CreditApplicationConfig;
  lookupMappingInfo: LookupMappingInformation[];
  relationshipToPrimaryApplicants: IDescriptionValuePair[];
  win = (window as any);
  isFormPristine = true;
  formSubmitted = false;
  isSaving = false;
  ssnLimit = 9;
  isBuyNow = false;
  isLoggedIn: boolean = false;
  SubPage = '';
  isFirstNameReadOnly: boolean = false;
  isMiddleNameReadOnly: boolean = false;
  isLastNameReadOnly: boolean = false;
  isEmailAddressReadOnly: boolean = false;
  isPhoneReadOnly: boolean = false;
  leadOpptId: number;
  preQualLeadInfo: PreQualLeadInfo;
  isVinAvailable = false;
  vehicleId: any;
  isLegacyCreditApp:boolean = false;
  legacyCaTitle:string;
  apiDomain = '';

  // Email validation attempt tracking
  private emailSubmissionAttempts: Map<string, number> = new Map();
  
  constructor(private fb: UntypedFormBuilder,
    @Inject('config') public config: IConfig,
    private nextComponentService: NextComponentService,
    private previousComponentService: PreviousComponentService,
    private creditAppService: CreditAppService,
    private analyticsEventService: AnalyticsEventService,
    private notificationService: NotificationsService,
    private stateService: StateService,
    private formService: FormInfoService
  ) {
    this.ssnMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    this.ssnLimit = 9;
  }

  public get personalInfo(): PersonalInformation2 {
    if(this.isLegacyCreditApp){
      /* istanbul ignore next */
      return (this.creditAppService &&
        this.creditAppService.LegacyCreditApplication[this.type] &&
        this.creditAppService.LegacyCreditApplication[this.type].personalInformation) || {};
    }else{
      return (this.creditAppService &&
        this.creditAppService.CreditApplication[this.type] &&
        this.creditAppService.CreditApplication[this.type].personalInformation) || {};
    }

  }

  public get relationshipInfo(): number {
    if(this.isLegacyCreditApp){
      /* istanbul ignore next */
      return (this.creditAppService &&
        this.creditAppService.LegacyCreditApplication.coBuyer &&
        this.creditAppService.LegacyCreditApplication.coBuyer.relationshipToApplicant) || null;
    }else{
      return (this.creditAppService &&
        this.creditAppService.CreditApplication.coBuyer &&
        this.creditAppService.CreditApplication.coBuyer.relationshipToApplicant) || null;
    }
  }

  public get securityInfo(): SecurityInformation {
    if(this.isLegacyCreditApp){
      /* istanbul ignore next */
      return (this.creditAppService &&
        this.creditAppService.LegacyCreditApplication[this.type] &&
        this.creditAppService.LegacyCreditApplication[this.type].financialInformation &&
        this.creditAppService.LegacyCreditApplication[this.type].financialInformation.securityInformation) || {};
    }else{
      return (this.creditAppService &&
        this.creditAppService.CreditApplication[this.type] &&
        this.creditAppService.CreditApplication[this.type].financialInformation &&
        this.creditAppService.CreditApplication[this.type].financialInformation.securityInformation) || {};
    }
  }

  ngOnInit() {
    // let myGarageFavoritesFlags = this._stateService.get('MyGarageFavorites') || { EnableFavorites: false,FavoritesMaxLimit: 0};

    const inputValue = (<HTMLInputElement>document.getElementById('ANUserId')) ? (<HTMLInputElement>document.getElementById('ANUserId')).value : '';

    const enableFavorites = (<HTMLInputElement>document.getElementById('enableFavorites')) ? (<HTMLInputElement>document.getElementById('enableFavorites')).value : '';

    if (inputValue && enableFavorites && (enableFavorites == 'True' || enableFavorites == 'true')) {
      this.isLoggedIn = true;
    }

    if (this.config.Sitecore && this.config.Sitecore.CreditApplicationConfig) {
      this.isBuyNow = this.config.Sitecore.isBuyNow;
      this.SCData = this.config.Sitecore.CreditApplicationConfig.PersonalInformation;
      this.creditAppConfigData = this.config.Sitecore.CreditApplicationConfig;
      this.lookupMappingInfo = this.config.Sitecore.LookupMappingInformation;
      this.setValidationPattern();
      this.relationshipToPrimaryApplicants = getLookupMappings(this.lookupMappingInfo, 'RelationshiptoPrimaryApplicantType');
      this.SubPage = this.config.Sitecore.SubPage ? this.config.Sitecore.SubPage : '';
      this.preQualLeadInfo = this.config.Sitecore.PreQualLeadInfo;
      this.isVinAvailable = this.preQualLeadInfo.vin !== '';
      this.isLegacyCreditApp = this.config.Sitecore.isLegacyCreditApp;
      this.apiDomain = this.config?.Sitecore?.apiDomain || '';
      if(this.isLegacyCreditApp){
        this.updateCtas();
      }
    }
    /* istanbul ignore next */
    if (this.config.Sitecore.isLegacyCreditApp){
      this.creditAppService.LeadDetails$.subscribe(res => {
        console.log('subscribed to response', res);
        if (res) {
          if (res?.OpptId !== 0) {
            this.leadOpptId = res?.OpptId;
          }
          if (res?.OpptVehicleId !== 0) {
            this.vehicleId = res?.OpptVehicleId;
          }
          if(this.type === StepType.Buyer){
              if (this.personalInfo.firstName !== '' && !res?.PreQualifiedAmount) {
                this.legacyCaTitle = this.config.Sitecore.CreditApplicationConfig.PersonalInformation.LeagcyCaTitle.replace(
                  '{FIRSTNAME}',
                  this.personalInfo.firstName
                );
                this.isFirstNameReadOnly = true;
              }
              if (this.personalInfo.firstName !== '' && res?.PreQualifiedAmount) {
                this.legacyCaTitle = this.config.Sitecore.CreditApplicationConfig.PersonalInformation.LeagcyQualifiedTitle.replace(
                  '{FIRSTNAME}',
                  this.personalInfo.firstName
                ).replace('{dollar_amount}', Math.round(res?.PreQualifiedAmount).toLocaleString());
                this.isFirstNameReadOnly = true;
              }
              if (this.personalInfo.middleName !== '') {
                this.isMiddleNameReadOnly = true;
              }
              if (this.personalInfo.lastName !== '') {
                this.isLastNameReadOnly = true;
              }
              if (this.personalInfo.emailAddress !== '') {
                this.isEmailAddressReadOnly = true;
              }
              if (this.personalInfo.phoneNumber !== '') {
                this.isPhoneReadOnly = true;
              }
          }

        }
      })
    }

    this.personalInfoForm = this.fb.group({
      FirstName: [
        this.truncateName(this.personalInfo.firstName != null ? this.personalInfo.firstName.trim() : this.personalInfo.firstName, 15),
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(this.namePattern)
        ]
      ],
      MI: [this.truncateName(this.personalInfo.middleName, 1), [
        Validators.minLength(0),
        Validators.maxLength(1),
        Validators.pattern(this.MIPattern)
      ]],
      LastName: [
        this.truncateName(this.personalInfo.lastName != null ? this.personalInfo.lastName.trim() : this.personalInfo.lastName, 35),
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(35),
          Validators.pattern(this.namePattern)
        ]
      ],
      Email: [
        this.truncateName(this.personalInfo.emailAddress, 40),
        [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]
      ],
      Phone: [
        this.PhoneNumberUpdate(this.personalInfo.phoneNumber), [
          Validators.minLength(14),
          Validators.maxLength(14),
          Validators.required,
          Validators.pattern(this.phonePattern)]
      ],
      DOB: [
        this.getFormatedDate(this.securityInfo.dob),
        [Validators.required,
        Validators.minLength(8),
        Validators.maxLength(10),
        Validators.pattern(this.datePattern),
        CustomValidator.DOBValidator]
      ],
      SSN: [
        this.maskSSN(this.securityInfo.ssn),
        [Validators.required,
        Validators.minLength(this.ssnLimit),
        Validators.maxLength(this.ssnLimit),
        Validators.pattern(this.ssnPattern),
        CustomValidator.SSNValidator,
        this.isLegacyCreditApp ? CustomValidator.SSNDuplicationValidator(this.type, { ...this.creditAppService.LegacyCreditApplication }, this.ssnLimit): CustomValidator.SSNDuplicationValidator(this.type, { ...this.creditAppService.CreditApplication }, this.ssnLimit)
        ]
      ],
      SSNConfim: !this.config.Sitecore.isLegacyCreditApp ? [
        this.maskSSN(this.securityInfo.ssn),
        [Validators.required,
        Validators.minLength(this.ssnLimit),
        Validators.maxLength(this.ssnLimit),
        Validators.pattern(this.ssnPattern),
        CustomValidator.SSNValidator,
        this.isLegacyCreditApp ? CustomValidator.SSNDuplicationValidator(this.type, { ...this.creditAppService.LegacyCreditApplication }, this.ssnLimit): CustomValidator.SSNDuplicationValidator(this.type, { ...this.creditAppService.CreditApplication }, this.ssnLimit)
        ]
      ] : '',
      RelationshipToPrimaryApplicant: [this.relationshipInfo || '', [Validators.required]],
    }, { validators: CustomValidator.matchSSN });

    this.personalInfoForm.controls.Phone.updateValueAndValidity();

    const relationshipToPrimaryApplicant = this.personalInfoForm.get('RelationshipToPrimaryApplicant');
    if (this.type === StepType.CoBuyer) {
      relationshipToPrimaryApplicant.setValidators([Validators.required]);
    } else {
      relationshipToPrimaryApplicant.setValidators(null);
    }

    this.personalInfoForm.controls.RelationshipToPrimaryApplicant.updateValueAndValidity();
    this.onChanges();

    if (this.personalInfoForm.valid) {
      this.formSubmitted = true;
      this.personalInfoForm.markAsPristine();
    }

    validateAllFormFields(this.personalInfoForm);

    this.IE = isIEorEdge();

    if (this.type === StepType.CoBuyer) {
      this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
        if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
          this.personalInfoForm.markAsDirty();
        }
      });
    } else {
      try {
        (window as any).buynow?.navigation?.showNext();
        (window as any).buynow?.navigation?.showPrev();
      } catch (e) {
        /* istanbul ignore next */
        console.error(e);
      }
    }

  }

  checkSecureSSN(item: boolean) {
    if (this.securityInfo.ssn && this.securityInfo.ssn.length === 4) {
      this.personalInfoForm.get('SSN').reset();
      this.personalInfoForm.get('SSNConfim').reset();
      this.securityInfo.ssn = '';

    }
    if (item) {
      this.ssnflag = !this.ssnflag;
      if (this.ssnflag) {
        this.ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.ssnLimit = 11;
        this.ssnPattern = this.ssnPattern1;
        this.setSSNValidator(this.ssnPattern, this.ssnLimit);
        this.personalInfoForm.setValidators(null);
        this.personalInfoForm.updateValueAndValidity();
        this.personalInfoForm.controls.SSN.setValue(this.maskSSN2(this.personalInfoForm.controls.SSN.value));
        this.personalInfoForm.controls.SSNConfim.setValue(this.maskSSN2(this.personalInfoForm.controls.SSNConfim.value));
        this.personalInfoForm.setValidators([CustomValidator.matchSSN]);
        this.personalInfoForm.updateValueAndValidity();
      } else {
        this.ssnMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
        this.ssnLimit = 9;
        this.ssnPattern = this.ssnPattern2;
        this.setSSNValidator(this.ssnPattern, this.ssnLimit);
        this.personalInfoForm.setValidators(null);
        this.personalInfoForm.updateValueAndValidity();
        this.personalInfoForm.controls.SSN.setValue(this.maskSSN(this.personalInfoForm.controls.SSN.value));
        this.personalInfoForm.controls.SSNConfim.setValue(this.maskSSN(this.personalInfoForm.controls.SSNConfim.value));
        this.personalInfoForm.setValidators([CustomValidator.matchSSN]);
        this.personalInfoForm.updateValueAndValidity();
      }
    }
  }
  setSSNValidator(pattern, mxlimit) {
    this.personalInfoForm.controls.SSN.clearValidators();
    this.personalInfoForm.controls.SSN.setValidators([
      Validators.required,
      Validators.minLength(mxlimit),
      Validators.maxLength(mxlimit),
      Validators.pattern(pattern),
      CustomValidator.SSNValidator,
      this.isLegacyCreditApp ? CustomValidator.SSNDuplicationValidator(this.type, { ...this.creditAppService.LegacyCreditApplication }, this.ssnLimit): CustomValidator.SSNDuplicationValidator(this.type, { ...this.creditAppService.CreditApplication }, this.ssnLimit),
    ]);
    this.personalInfoForm.controls.SSN.updateValueAndValidity({ emitEvent: false, onlySelf: true });

    this.personalInfoForm.controls.SSNConfim.clearValidators();
    this.personalInfoForm.controls.SSNConfim.setValidators([
      Validators.required,
      Validators.minLength(mxlimit),
      Validators.maxLength(mxlimit),
      Validators.pattern(pattern),
      CustomValidator.SSNValidator,
      this.isLegacyCreditApp ? CustomValidator.SSNDuplicationValidator(this.type, { ...this.creditAppService.LegacyCreditApplication }, this.ssnLimit): CustomValidator.SSNDuplicationValidator(this.type, { ...this.creditAppService.CreditApplication }, this.ssnLimit)
    ]);


    this.personalInfoForm.controls.SSNConfim.updateValueAndValidity({ emitEvent: false, onlySelf: true });
  }

  onChanges(): any {
    this.personalInfoForm.valueChanges.pipe(take(1)).subscribe(val => {
      if (this.isFormPristine) {
        this.isFormPristine = false;
        if (this.type === StepType.Buyer && this.creditAppService.CreditApplication.step === 0) {
          this.analyticsEventService.reportAnalyticsEvent(
            new FormStarted(new StepComponent(PersonalInfoComponent,
              ComponentName.CoBuyerPersonalInfoComponent,
              ComponentGroup.PersonalInfo, true, this.type))
          );
        }
      }
    });
  }

  setValidationPattern() {
    this.phonePattern = this.SCData.PhoneNumberRegExp ? this.SCData.PhoneNumberRegExp : this.phonePattern;
    this.datePattern = this.SCData.DOBRegExp ? this.SCData.DOBRegExp : this.datePattern;
    this.ssnPattern = this.SCData.SSNRegExp ? this.SCData.SSNRegExp : this.ssnPattern2;
  }

  maskSSN(ssn) {
    if (ssn) {
      let ssncopy = ssn;
      if (ssncopy && ssncopy.length === 4) {
        ssncopy = '00000' + ssn;
      }
      let p = ssncopy.match(/\d/g);
      p = p.join('');
      return p.substr(0, 3) + p.substr(3, 2) + p.substr(5, 4);
    }
    return '';
  }

  maskSSN2(ssn) {
    if (ssn) {
      let ssncopy = ssn;
      if (ssncopy && ssncopy.length === 4) {
        ssncopy = '00000' + ssn;
      }
      let p = ssncopy.match(/\d/g);
      p = p.join('');
      return p.substr(0, 3) + '-' + p.substr(3, 2) + '-' + p.substr(5, 4);
    }
    return '';
  }

  truncateName(name: string, size: number) {
    if (typeof name === 'string') {
      return name.substr(0, size);
    }
    return name;
  }

  scrollInto($event) {
    if (this.win.innerWidth < 480) {
      $event.srcElement.scrollIntoView();
    }
  }

  async goNext() {
    let ca: any;
    getBackButton();
    this.validateAllFormFields(this.personalInfoForm);

    if (!this.personalInfoForm.valid) {
      return;
    }

    if ((this.personalInfoForm.valid && this.personalInfoForm.dirty)
      || (this.personalInfoForm.valid && !this.formSubmitted)) {

      const emailControl = this.personalInfoForm.get('Email');
      const phoneControl = this.personalInfoForm.get('Phone');
      const phone = (phoneControl.value || '').replace(/\D/g, '');
      const request: IValidateLeadRequest = {
        firstName: this.personalInfoForm.get('FirstName').value || '',
        lastName: this.personalInfoForm.get('LastName').value || '',
        hyperionId: this.config.Sitecore?.Hid || '',
        email: emailControl.value || '',
        phone
      };

      this.isSaving = true;
      this.toggleNav();
      let leadValidationResponse = null;
      if( this.shouldValidateLead()){
        leadValidationResponse = await this.creditAppService.validateLead(request, this.SubPage, this.apiDomain);
        const emailRiskLevel = leadValidationResponse?.Reasons?.Email?.RiskLevel;
        const phoneRisk = leadValidationResponse?.Reasons?.Phone?.RiskLevel === 'High';
        const data = [];

        // Track email submission attempts
        const emailValue = emailControl.value || '';
        const currentAttempts = this.emailSubmissionAttempts.get(emailValue) || 0;
        this.emailSubmissionAttempts.set(emailValue, currentAttempts + 1);

        // Check email risk level
        const emailRiskHigh = emailRiskLevel === 'High';
        
        if (emailRiskHigh) {
          data.push('Email');
          emailControl.setErrors({ ...emailControl.errors, riskHigh: true });
          emailControl.markAsTouched();
        }
        if (phoneRisk) {
          data.push('Phone');
          phoneControl.setErrors({ ...phoneControl.errors, riskHigh: true });
          phoneControl.markAsTouched();
        }

        if (emailRiskHigh || phoneRisk) {
          this.formService.reportValidationFailure(data.join(','));
          this.isSaving = false;
          this.toggleNav();
          return;
        }

      }

      this.proceedWithSave(leadValidationResponse?.ValidationId);

    } else {
      if (this.personalInfoForm.valid) {
        this.loadNextComponent();
      }
    }
  }

  shouldValidateLead() {
    const enableLeadValidation = !!this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.EnableLeadValidation; 
    const shouldValidate = enableLeadValidation && 
        (
          (this.personalInfoForm.get('Email').value !==  this.config?.Sitecore?.PreQualLeadInfo?.email) || 
          (this.normalizePhone(this.personalInfoForm.get('Phone').value) !==  this.normalizePhone(this.config?.Sitecore?.PreQualLeadInfo?.phone))
        );
    return shouldValidate;
  }

  private normalizePhone(value: string): string {
    return (value || '').replace(/\D/g, '');
  }


  proceedWithSave(validationId: any) {
    let ca: any;
    ca.validation = {
            enable: !this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.EnableLeadValidation ? true : false,
            id: validationId || null
    };
    if (this.config?.Sitecore?.isLegacyCreditApp) {
      ca = { ...this.creditAppService.LegacyCreditApplication };
    } else {
      ca = { ...this.creditAppService.CreditApplication };
    }

    const stepCount = (this.type === StepType.Buyer ? 1 : 7);
    ca.step = stepCount;

    this.personalInfoForm.get('FirstName').setValue(this.personalInfoForm.get('FirstName').value.trim());
    ca[this.type].personalInformation.firstName = this.personalInfoForm.get('FirstName').value;
    this.personalInfoForm.get('LastName').setValue(this.personalInfoForm.get('LastName').value.trim());
    ca[this.type].personalInformation.lastName = this.personalInfoForm.get('LastName').value;
    ca[this.type].personalInformation.middleName = this.personalInfoForm.get('MI').value;
    ca[this.type].personalInformation.emailAddress = this.personalInfoForm.get('Email').value;
    ca[this.type].personalInformation.phoneNumber = this.personalInfoForm.get('Phone').value;

    const dob: string = this.personalInfoForm.get('DOB').value;
    const dobDate: Date = new Date(dob);
    if (this.config?.Sitecore?.isLegacyCreditApp) {
      const updateddate = (new Date(dob)).toISOString().split('T')[0];
      delete ca[this.type].personalInformation.dateOfBirth;
      delete ca[this.type].personalInformation.ssn;
      ca[this.type].financialInformation.securityInformation.dob = updateddate;
    } else {
      ca[this.type].personalInformation.dateOfBirth = dob;
      ca[this.type].financialInformation.securityInformation.dob = dob;
    }

    if (!this.config?.Sitecore?.isLegacyCreditApp) {
      ca[this.type].financialInformation.securityInformation.dobDate = dobDate.getDate();
      ca[this.type].financialInformation.securityInformation.dobMonth = dobDate.getMonth() + 1;
      ca[this.type].financialInformation.securityInformation.dobYear = dobDate.getFullYear();
    }

    const ssn: string = this.personalInfoForm.get('SSN').value.replace(/-/g, '');
    ca[this.type].financialInformation.securityInformation.ssn = ssn;
    if (!this.config?.Sitecore?.isLegacyCreditApp) {
      ca[this.type].financialInformation.securityInformation.ssn1 = ssn.substr(0, 3);
      ca[this.type].financialInformation.securityInformation.ssn2 = ssn.substr(3, 2);
      ca[this.type].financialInformation.securityInformation.ssn3 = ssn.substr(5, 4);
    }
    if (this.type === StepType.CoBuyer) {
      ca.coBuyer.relationshipToApplicant = this.personalInfoForm.get('RelationshipToPrimaryApplicant').value;
    }

    /* istanbul ignore next */
    if (this.config?.Sitecore?.isLegacyCreditApp) {
      if (this.isVinAvailable) {
        ca.shortForm.vehicleInformation.make = this.preQualLeadInfo.make;
        ca.shortForm.vehicleInformation.year = this.preQualLeadInfo.year;
        ca.shortForm.vehicleInformation.model = this.preQualLeadInfo.model;
        ca.shortForm.vehicleInformation.vin = this.preQualLeadInfo.vin;
        ca.shortForm.vehicleInformation.stockType = this.preQualLeadInfo.inventoryType;
      }
      this.creditAppService.HyperionId$.subscribe(res => {
        ca.shortForm.vehicleInformation.hyperionId = this.config.Sitecore.Hid ? this.config.Sitecore.Hid : (res ? res : '');
      });
      this.creditAppService.YMMTDetails$.subscribe(res => {
        console.log('subscribed to response', res);
        if (res) {
          ca.shortForm.vehicleInformation.make = res?.make ? res.make : null;
          ca.shortForm.vehicleInformation.year = res?.year ? parseInt(res?.year) : 0;
          ca.shortForm.vehicleInformation.model = res?.model ? res?.model : null;
          ca.shortForm.vehicleInformation.trim = res?.trim ? res?.trim : null;
          ca.shortForm.vehicleInformation.stockType = parseInt(res?.stockType) === 0 ? 'NEW' : 'USED';
        }
      });
      ca.opptId = this.leadOpptId ? this.leadOpptId.toString() : '';
      ca.shortForm.dealParameters.opptId = this.leadOpptId ? this.leadOpptId.toString() : '';
      ca.shortForm.dealParameters.vehicleId = this.vehicleId ? parseInt(this.vehicleId) : 0;
    }

    this.creditAppService.SaveCreditApp(ca, this.SubPage).subscribe(response => {
      if (response.isSuccess) {
        this.isSaving = false;
        this.formSubmitted = true;
        this.personalInfoForm.markAsPristine();
        this.loadNextComponent();
      } else {
        this.isSaving = false;
        this.reportErrorResponse(response);
      }
      this.toggleNav();
    }, error => {
      this.isSaving = false;
      this.toggleNav();
      this.reportErrorResponse(error);
    });
  }

  toggleNav() {
    try {
      if (this.isBuyNow) {
        /* istanbul ignore next */
        (window as any)?.buynow?.navigation?.toggleNavigationDisableState();
      }
    } catch (e) {
      /* istanbul ignore next */
      console.log(e);
    }
  }

  loadNextComponent() {
    let nextComponent: IComponentDetails;
    if (this.type === StepType.Buyer) {
      nextComponent = {
        groupName: ComponentGroup.ResidenceInfo,
        component: new StepComponent(
          ResidenceInfoComponent,
          ComponentName.ResidenceInfoComponent,
          ComponentGroup.ResidenceInfo,
          true
        ),
        componentName: ComponentName.ResidenceInfoComponent
      };
      this.analyticsEventService.reportAnalyticsEvent(
        new NextCTAClick(
          new StepComponent(
            PersonalInfoComponent,
            ComponentName.PersonalInfoComponent,
            ComponentGroup.PersonalInfo,
            true,
            this.type
          )
        )
      );
      try {
        (window as any)?.buynow?.navigation?.hideNext();
        (window as any)?.buynow?.navigation?.hidePrev();
      } catch (e) {
        /* istanbul ignore next */
        console.error(e);
      }
    } else {
      nextComponent = {
        groupName: ComponentGroup.CoBuyerResidence,
        component: new StepComponent(
          ResidenceInfoComponent,
          ComponentName.CoBuyerResidenceInfoComponent,
          ComponentGroup.CoBuyerResidence,
          true,
          StepType.CoBuyer
        ),
        componentName: ComponentName.CoBuyerResidenceInfoComponent
      };
      this.analyticsEventService.reportAnalyticsEvent(
        new NextCTAClick(
          new StepComponent(
            PersonalInfoComponent,
            ComponentName.CoBuyerPersonalInfoComponent,
            ComponentGroup.PersonalInfo,
            true,
            this.type
          )
        )
      );
    }

    this.nextComponentService.loadComponent(nextComponent);
  }

  reportErrorResponse(errorData: any) {
    const analyticsErrorResponse: IAnalyticsErrorResponse = {
      error: errorData.statusCode ? errorData.statusCode : UDOConstant.ErrorCode,
      error_message: errorData.message ? errorData.message : UDOConstant.ServiceUnavailable,
      error_type: ErrorType.CreditAppNotSaved
    };
    this.analyticsEventService.reportAnalyticsEvent(
      new ServerError(new StepComponent(PersonalInfoComponent,
        ComponentName.PersonalInfoComponent,
        ComponentGroup.PersonalInfo, true, this.type),
        analyticsErrorResponse));
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  goBack() {
    let currentComponent: IComponentDetails;
    if (this.type === StepType.CoBuyer) {
      currentComponent = {
        groupName: ComponentGroup.CoBuyerPersonal,
        component: new StepComponent(PersonalInfoComponent,
          ComponentName.CoBuyerPersonalInfoComponent, ComponentGroup.CoBuyerPersonal, true, StepType.CoBuyer),
        componentName: ComponentName.CoBuyerPersonalInfoComponent
      };
    }
    this.previousComponentService.loadComponent(currentComponent);
  }

  PhoneNumberUpdate(phone) {
    if (phone) {
      let p = phone.match(/\d/g);
      p = p.join('');
      return '(' + p.substr(0, 3) + ') ' + p.substr(3, 3) + '-' + p.substr(6, 4);
    }
    return '';
  }
  isDesktop() {
    return window.innerWidth > 1023;
  }

  isMedium() {
    return window.innerWidth > 524 && window.innerWidth < 1024;
  }

  isSmallm() {
    return window.innerWidth <= 524;
  }

  getFormatedDate(date) {
    if (date) {
      const dat = new Date(date);
      const dd = dat.getDate();
      const mm = dat.getMonth() + 1; // January is 0!
      let dd2 = '';
      let mm2 = '';
      const yyyy = dat.getFullYear();
      if (dd < 10) {
        dd2 = '0' + dd;
      } else {
        dd2 = dd.toString();
      }
      if (mm < 10) {
        mm2 = '0' + mm;
      } else {
        mm2 = mm.toString();
      }
      return mm2 + '/' + dd2 + '/' + yyyy;
    }
    return '';
  }

  /* istanbul ignore next */
  updateCtas() {
    try {
      (window as any).standalonePrequal.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }


}
